import certificationsData from '../data/certifications.json';
import { Certification } from '../models/certification.interface';

export class CertificationsService {
    private certifications: Certification[] = [];

    constructor() {
        this.certifications = certificationsData.certifications as Certification[];
    }

    getCertifications(): Certification[] {
        return this.certifications;
    }
}

export const certificationsService = new CertificationsService();
